import React, { useState } from "react";
import {
  Button,
  TextField,
  Modal,
  Box,
  Typography,
  Slide,
  Grid,
  FormControl,
  RadioGroup,
  FormControlLabel,
  Radio,
  Card,
  CardContent,
  IconButton,
  Select,
  MenuItem,
} from "@mui/material";
import { AddPhotoAlternate, DeleteOutline } from "@mui/icons-material";
import { craneOperatorApis } from "../../../Data/axios";

export default function AddCraneOperator({ open, handleClose, onCraneOperatorAdded }) {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [mobile, setMobile] = useState("");
  const [state, setState] = useState("");
  const [pinCode, setPinCode] = useState("");
  const [address, setAddress] = useState("");
  const [selectedRadio, setSelectedRadio] = useState("male");
  const [profileImage, setProfileImage] = useState(null);

  const indianStates = [
    "Andhra Pradesh",
    "Arunachal Pradesh",
    "Assam",
    "Bihar",
    "Chhattisgarh",
    "Goa",
    "Gujarat",
    "Haryana",
    "Himachal Pradesh",
    "Jharkhand",
    "Karnataka",
    "Kerala",
    "Madhya Pradesh",
    "Maharashtra",
    "Manipur",
    "Meghalaya",
    "Mizoram",
    "Nagaland",
    "Odisha",
    "Punjab",
    "Rajasthan",
    "Sikkim",
    "Tamil Nadu",
    "Telangana",
    "Tripura",
    "Uttar Pradesh",
    "Uttarakhand",
    "West Bengal",
    "Andaman and Nicobar Islands",
    "Chandigarh",
    "Dadra and Nagar Haveli and Daman and Diu",
    "Delhi",
    "Jammu and Kashmir",
    "Ladakh",
    "Lakshadweep",
    "Puducherry",
  ];

  const handleFormReset = () => {
    setName("");
    setEmail("");
    setMobile("");
    setState("");
    setPinCode("");
    setAddress("");
    setSelectedRadio("male");
    setProfileImage(null);
  };

  const handleCloseModal = () => {
    handleFormReset();
    handleClose();
  };

  const handleFileChange = (event, setter) => {
    if (event.target.files && event.target.files[0]) {
      const file = event.target.files[0];
      setter(file);
    }
  };

  const handleFileRemove = (setter) => {
    setter(null);
  };

  const handleSaveCraneOperator = async () => {
    try {
      if (!name || !email || !mobile || !state || !pinCode || !address) {
        alert("Please fill in all required fields");
        return;
      }

      let genderValue;
      if (selectedRadio === "male") {
        genderValue = 1;
      } else if (selectedRadio === "female") {
        genderValue = 2;
      } else {
        genderValue = 3; // Others
      }
      
      const userDataNew = localStorage.getItem("user-info");
      let creator = "";
      if (userDataNew) {
        const parsedData = JSON.parse(userDataNew);
        creator = parsedData.value.empid;
      }
      
      const formData = new FormData();
      formData.append("username", name);
      formData.append("email", email);
      formData.append("phone", mobile);
      formData.append("role", "5"); // Crane Operator role is 5
      formData.append("address", address);
      formData.append("state", state);
      formData.append("pincode", pinCode);
      formData.append("ref", creator);
      formData.append("gender", genderValue);

      if (profileImage) {
        formData.append("image", profileImage);
      }

      console.log("Submitting form data:");
      for (let [key, value] of formData.entries()) {
        if (value instanceof File) {
          console.log(`${key}: File - ${value.name} (${value.size} bytes)`);
        } else {
          console.log(`${key}: ${value}`);
        }
      }

      const response = await craneOperatorApis.add(formData);
      if (response && response.success) {
        alert("Crane operator added successfully!");
        if (onCraneOperatorAdded) onCraneOperatorAdded();
        handleCloseModal();
      } else {
        const errorMessage =
          response?.message || "Failed to add crane operator. Please try again.";
        console.error("API Error:", response);
        alert(errorMessage);
      }
    } catch (error) {
      console.error("Error adding crane operator:", error);
      let errorMessage = "An error occurred while adding the crane operator.";
      if (error.response) {
        console.error("Error response:", error.response.data);
        errorMessage = error.response.data?.message || errorMessage;
      } else if (error.request) {
        console.error("Error request:", error.request);
        errorMessage =
          "No response received from server. Please check your connection.";
      }

      alert(errorMessage);
    }
  };

  const inputProps = {
    sx: {
      bgcolor: "#f9f9f9",
      "& .MuiOutlinedInput-root": {
        "& fieldset": {
          borderColor: "#e0e0e0",
        },
        "&:hover fieldset": {
          borderColor: "#bdbdbd",
        },
      },
      "& .MuiInputBase-input": {
        color: "#424242",
      },
    },
  };

  const FileInput = ({ title, file, onFileChange, onFileRemove, accept }) => (
    <Box sx={{ mb: 2 }}>
      <Typography variant="body1" mb={1} sx={{ color: "#212121" }}>
        {title}
      </Typography>
      <Box
        sx={{
          border: "1px dashed #bdbdbd",
          borderRadius: 1,
          p: 2,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          bgcolor: "#f5f5f5",
          position: "relative",
        }}
      >
        {file ? (
          <Box sx={{ width: "100%" }}>
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                mb: 1,
              }}
            >
              <Typography
                variant="body2"
                color="textSecondary"
                sx={{
                  maxWidth: "70%",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                }}
              >
                {file.name}
              </Typography>
              <IconButton
                onClick={() => onFileRemove()}
                size="small"
                color="error"
              >
                <DeleteOutline />
              </IconButton>
            </Box>
            {file.type.startsWith("image/") && (
              <Box
                sx={{
                  width: "100%",
                  height: 100,
                  backgroundImage: `url(${URL.createObjectURL(file)})`,
                  backgroundSize: "contain",
                  backgroundPosition: "center",
                  backgroundRepeat: "no-repeat",
                }}
              />
            )}
          </Box>
        ) : (
          <>
            <input
              type="file"
              id={`file-input-${title.replace(/\s+/g, "-").toLowerCase()}`}
              style={{ display: "none" }}
              onChange={(e) => onFileChange(e)}
              accept={accept || "image/*"}
            />
            <label
              htmlFor={`file-input-${title.replace(/\s+/g, "-").toLowerCase()}`}
            >
              <Button
                variant="text"
                component="span"
                startIcon={<AddPhotoAlternate />}
                sx={{ color: "#1d82f5" }}
              >
                Upload File
              </Button>
            </label>
            <Typography variant="caption" color="textSecondary" sx={{ mt: 1 }}>
              Click to upload or drag and drop
            </Typography>
          </>
        )}
      </Box>
    </Box>
  );

  return (
    <Modal open={open} onClose={handleCloseModal} closeAfterTransition>
      <Slide direction="left" in={open}>
        <Box
          sx={{
            position: "absolute",
            top: 0,
            right: 0,
            width: "85%",
            height: "100%",
            bgcolor: "#f5f5f5",
            boxShadow: 24,
            p: 4,
            overflow: "auto",
          }}
        >
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
            mb={3}
          >
            <Typography variant="h3" component="h2" sx={{ color: "#212121" }}>
              Add New Crane Operator
            </Typography>
            <Button
              onClick={handleCloseModal}
              variant="outlined"
              sx={{
                borderColor: "#bdbdbd",
                color: "#424242",
                "&:hover": {
                  borderColor: "#9e9e9e",
                  bgcolor: "rgba(0, 0, 0, 0.04)",
                },
              }}
            >
              Close
            </Button>
          </Box>
          <Card
            sx={{
              p: 2,
              bgcolor: "#ffffff",
              boxShadow: "0px 2px 10px rgba(0, 0, 0, 0.08)",
            }}
          >
            <CardContent>
              <Box sx={{ mb: 4 }}>
                <Grid container spacing={3}>
                  {/* Personal Information */}
                  <Grid item xs={12}>
                    <Typography variant="h6" sx={{ color: "#212121", mb: 2 }}>
                      Personal Information
                    </Typography>
                  </Grid>

                  {/* Profile Image */}
                  <Grid item xs={12} md={3}>
                    <FileInput
                      title="Profile Image"
                      file={profileImage}
                      onFileChange={(e) => handleFileChange(e, setProfileImage)}
                      onFileRemove={() => handleFileRemove(setProfileImage)}
                      accept="image/*"
                    />
                  </Grid>

                  {/* Name */}
                  <Grid item xs={12} md={3}>
                    <Typography
                      variant="body1"
                      mb={1}
                      sx={{ color: "#212121" }}
                    >
                      Name <span style={{ color: "red" }}>*</span>
                    </Typography>
                    <TextField
                      fullWidth
                      placeholder="Enter name"
                      size="small"
                      value={name}
                      onChange={(e) => setName(e.target.value)}
                      InputProps={inputProps}
                    />
                  </Grid>

                  {/* Email */}
                  <Grid item xs={12} md={3}>
                    <Typography
                      variant="body1"
                      mb={1}
                      sx={{ color: "#212121" }}
                    >
                      Email <span style={{ color: "red" }}>*</span>
                    </Typography>
                    <TextField
                      fullWidth
                      placeholder="example@email.com"
                      size="small"
                      type="email"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      InputProps={inputProps}
                    />
                  </Grid>

                  {/* Phone */}
                  <Grid item xs={12} md={3}>
                    <Typography
                      variant="body1"
                      mb={1}
                      sx={{ color: "#212121" }}
                    >
                      Phone <span style={{ color: "red" }}>*</span>
                    </Typography>
                    <TextField
                      fullWidth
                      placeholder="+91 1234567890"
                      size="small"
                      value={mobile}
                      onChange={(e) => setMobile(e.target.value)}
                      InputProps={inputProps}
                    />
                  </Grid>

                  {/* Gender */}
                  <Grid item xs={12} md={3}>
                    <Typography
                      variant="body1"
                      mb={1}
                      sx={{ color: "#212121" }}
                    >
                      Gender <span style={{ color: "red" }}>*</span>
                    </Typography>
                    <FormControl>
                      <RadioGroup
                        row
                        value={selectedRadio}
                        onChange={(e) => setSelectedRadio(e.target.value)}
                      >
                        <FormControlLabel
                          value="male"
                          control={
                            <Radio
                              sx={{
                                color: "#9e9e9e",
                                "&.Mui-checked": { color: "#1d82f5" },
                              }}
                            />
                          }
                          label="Male"
                          sx={{ color: "#424242" }}
                        />
                        <FormControlLabel
                          value="female"
                          control={
                            <Radio
                              sx={{
                                color: "#9e9e9e",
                                "&.Mui-checked": { color: "#1d82f5" },
                              }}
                            />
                          }
                          label="Female"
                          sx={{ color: "#424242" }}
                        />
                        <FormControlLabel
                          value="others"
                          control={
                            <Radio
                              sx={{
                                color: "#9e9e9e",
                                "&.Mui-checked": { color: "#1d82f5" },
                              }}
                            />
                          }
                          label="Others"
                          sx={{ color: "#424242" }}
                        />
                      </RadioGroup>
                    </FormControl>
                  </Grid>

                  {/* State */}
                  <Grid item xs={12} md={3}>
                    <Typography
                      variant="body1"
                      mb={1}
                      sx={{ color: "#212121" }}
                    >
                      State <span style={{ color: "red" }}>*</span>
                    </Typography>
                    <FormControl fullWidth size="small">
                      <Select
                        value={state}
                        onChange={(e) => setState(e.target.value)}
                        displayEmpty
                        sx={{
                          backgroundColor: "#f9f9f9",
                          "& .MuiOutlinedInput-notchedOutline": {
                            borderColor: "#e0e0e0",
                          },
                          "&:hover .MuiOutlinedInput-notchedOutline": {
                            borderColor: "#bdbdbd",
                          },
                          "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                            borderColor: "#1d82f5",
                          },
                          fontFamily: "Ubuntu, sans-serif",
                        }}
                        renderValue={(selected) => {
                          if (!selected) {
                            return (
                              <em
                                style={{
                                  color: "#757575",
                                  fontFamily: "Ubuntu, sans-serif",
                                }}
                              >
                                Select state
                              </em>
                            );
                          }
                          return selected;
                        }}
                        inputProps={{ "aria-label": "Select state" }}
                        MenuProps={{
                          PaperProps: {
                            style: {
                              maxHeight: 250,
                              width: 250,
                            },
                          },
                        }}
                      >
                        <MenuItem
                          disabled
                          value=""
                          sx={{ fontFamily: "Ubuntu, sans-serif" }}
                        >
                          <em>Select state</em>
                        </MenuItem>
                        {indianStates.map((stateName) => (
                          <MenuItem
                            key={stateName}
                            value={stateName}
                            sx={{ fontFamily: "Ubuntu, sans-serif" }}
                          >
                            {stateName}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid>

                  {/* Pin Code */}
                  <Grid item xs={12} md={3}>
                    <Typography
                      variant="body1"
                      mb={1}
                      sx={{ color: "#212121" }}
                    >
                      Pin Code <span style={{ color: "red" }}>*</span>
                    </Typography>
                    <TextField
                      fullWidth
                      placeholder="Enter pin code"
                      size="small"
                      value={pinCode}
                      onChange={(e) => setPinCode(e.target.value)}
                      InputProps={inputProps}
                    />
                  </Grid>

                  {/* Address */}
                  <Grid item xs={12} md={6}>
                    <Typography
                      variant="body1"
                      mb={1}
                      sx={{ color: "#212121" }}
                    >
                      Address <span style={{ color: "red" }}>*</span>
                    </Typography>
                    <TextField
                      fullWidth
                      placeholder="Enter full address"
                      size="small"
                      multiline
                      rows={2}
                      value={address}
                      onChange={(e) => setAddress(e.target.value)}
                      InputProps={inputProps}
                    />
                  </Grid>
                </Grid> 
              </Box>

              {/* Form buttons */}
              <Box display="flex" gap={2} mt={3}>
                <Button
                  variant="contained"
                  onClick={handleSaveCraneOperator}
                  sx={{
                    bgcolor: "#4285F4",
                    color: "white",
                    "&:hover": { bgcolor: "#3367D6" },
                    fontWeight: 500,
                    textTransform: "none",
                    padding: "8px 16px",
                  }}
                >
                  Save
                </Button>
                <Button
                  variant="outlined"
                  onClick={handleCloseModal}
                  sx={{
                    borderColor: "#bdbdbd",
                    color: "#424242",
                    "&:hover": {
                      borderColor: "#9e9e9e",
                      bgcolor: "rgba(0, 0, 0, 0.04)",
                    },
                    textTransform: "none",
                    padding: "8px 16px",
                  }}
                >
                  Cancel
                </Button>
              </Box>
            </CardContent>
          </Card>
        </Box>
      </Slide>
    </Modal>
  );
}